import axios, { AxiosResponse } from "axios";
import { Dominios } from "../../../utils/enums";
import { ciudades, comunas, Participante, ParticipanteRequest } from "../models/participantes";
import axiosInstance from "../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../dtos/ListResponseDto";
import { selectorTransversal } from "../../../dtos/selector";

const getListaParticipantes = async (idMutuo: number) => {

    const axiosResponse: Promise<AxiosResponse<ListResponseDto<Participante>>> = axiosInstance.get(`siscred-api-participantes/v1/participantes-mutuo/lista-participante`, {
        params: {
            idMutuo: idMutuo,
        }
    });

    return axiosResponse;
}

const getParticipante = async (data: ParticipanteRequest) => {
    const response: AxiosResponse = await axiosInstance.get(
        `siscred-api-participantes/v1/participantes-mutuo/obtener-participante`,
        {
            params: {
                codigoTipoParticipante: data.codigoTipoParticipante,
                rut: data.rut,
                mutuoId: data.mutuoId
            }
        }
    );
    return response;
};

const getConyuge = async (data: ParticipanteRequest) => {
    const response: AxiosResponse = await axiosInstance.get(
        `siscred-api-participantes/v1/participantes-mutuo/obtener-conyuge`,
        {
            params: {
                rut: data.rut,
                mutuoId: data.mutuoId
            }
        }
    );
    return response;
};

const getCiudades = async () => {
    const response: AxiosResponse<ListResponseDto<ciudades>> = await axiosInstance.get(`siscred-api-transversal/v1/locaciones/obtener-datos-ciudad`);
    return response;
};

const getComunaPorId = async (idCiudad: string) => {
    if (!idCiudad)
        return;

    const response: AxiosResponse<ListResponseDto<comunas>> = await axiosInstance.get(
        `siscred-api-transversal/v1/locaciones/comunas-ciudad`,
        { params: { codigoCiudad: idCiudad } }
    );
    return response;
};

const getValoresDominio = async (codigoDominio: Dominios) => {
    const response: AxiosResponse<ListResponseDto<selectorTransversal>> = await axiosInstance.get(`siscred-api-transversal/v1/dominio/obtener-datos-dominio`, {
        params: {
            codigoDominio: codigoDominio
        }
    }
    );
    return response;
};

const obtenerMutuoComple = async (idSolicitud: number) => {

    const axiosResponse: AxiosResponse = await axiosInstance.get(`siscred-api-participantes/v1/participantes-mutuo/obtener-mutuo-complementario`, {
        params: {
            idSolicitud: idSolicitud
        }
    });

    return axiosResponse;
}
const obtenerFechaGratuidad = async (idMutuo: number, mesesGratuidad: number) => {

    const axiosResponse: AxiosResponse = await axiosInstance.get(`siscred-api-participantes/v1/seguros-participantes-mutuo/fecha-vigencia-seguro`, {
        params: {
            idMutuo: idMutuo,
            mesesGratuidad: mesesGratuidad
        }
    });

    return axiosResponse;
}

const copyParticipantes = async (idSolicitud: string | number) => {
    const response: AxiosResponse = await axiosInstance.post(
        `siscred-api-participantes/v1/participantes-mutuo/copiar-complementario`,
        { idSolicitud: Number(idSolicitud) }
    );
    return response;
}

export {
    getListaParticipantes,
    getParticipante,
    getCiudades,
    getComunaPorId,
    getValoresDominio,
    getConyuge,
    obtenerMutuoComple,
    obtenerFechaGratuidad,
    copyParticipantes
}